// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"43915a7d","239":"2e861d8d","453":"ad181d33","732":"d2d6f75f"}[chunkId] + ".chunk.js";
};